import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Web3StatusContext } from "../contexts/Web3StatusContext";
import moment from "moment";
import "moment/locale/tr";
import "moment/locale/ja";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const { AccountData, ContractData, ContractForm } = newContextComponents;

class DatePriceProgress extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    firstDateKey : null,
    lastDateKey : null,
    firstRateKey : null,
    lastRateKey : null,
    currentRateKey : null
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
  
    const firstDateKey = contract.methods["getTime"].cacheCall(this.props.firstDateName);
    const lastDateKey = contract.methods["getTime"].cacheCall(this.props.lastDateName);
    const firstRateKey = contract.methods[this.props.firstRateName].cacheCall();
    const lastRateKey = contract.methods[this.props.lastRateName].cacheCall();
    const currentRateKey = contract.methods[this.props.currentRateName].cacheCall();
  
    this.setState({ firstDateKey,
      lastDateKey,
      firstRateKey,
      lastRateKey,
      currentRateKey });
  }
  

  // destructure drizzle and drizzleState from props
  render() {
    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    const unixFirstDateContract = GAMEFORESTSale["getTime"][this.state.firstDateKey];
    const unixLastDateContract = GAMEFORESTSale["getTime"][this.state.lastDateKey];
    
    if(unixFirstDateContract !== undefined && unixLastDateContract !== undefined) {
      const unixFirstDateValue = parseInt(unixFirstDateContract.value);
      const unixLastDateValue = parseInt(unixLastDateContract.value);

      const period = unixLastDateValue - unixFirstDateValue;
      const dividedPeriod = period/3;
      
      const nowUnix = Math.floor(Date.now() / 1000);
      var nowRelative = nowUnix - unixFirstDateValue;
      var nowPeriod = nowRelative;
      if(nowPeriod > dividedPeriod) {
        nowPeriod = dividedPeriod;
      }
      var nowPeriod2 = nowRelative - dividedPeriod;
      if(nowPeriod2 > dividedPeriod) {
        nowPeriod2 = dividedPeriod;
      }
      var nowPeriod3 = nowRelative - 2 * dividedPeriod;
      if(nowPeriod3 > dividedPeriod) {
        nowPeriod3 = dividedPeriod;
      }

      var firstProgress = <ProgressBar animated min={0} max={period} now={nowPeriod} variant="success" />;
      var secondProgress = <ProgressBar animated min={0} max={period} now={nowPeriod2} variant="warning" />;
      var thirdProgress = <ProgressBar animated min={0} max={period} now={nowPeriod3} variant="danger" />;

      if(nowPeriod < 0) {
        firstProgress = <ProgressBar animated min={0} max={period} now={0} variant="success" label={`${50}%`} />;
      }

      if(nowPeriod2 < 0) {
        secondProgress = "";
      }

      if(nowPeriod3 < 0) {
        thirdProgress = "";
      }

      const firstDate = new Date(unixFirstDateValue * 1000);
      const lastDate = new Date(unixLastDateValue * 1000);

      var remainingSuffix = "";
      var remainingPrefix = "";

      if(this.context.i18n != null)
        moment.locale(this.context.i18n.languages[0]);
      var dateFormat = 'DD-MM-YYYY HH:mm';

      if(nowRelative < 0) {
        remainingPrefix = <Trans>date_price_progress.to_start</Trans>;
        remainingSuffix = moment(firstDate, dateFormat).from(nowUnix*1000);
      }

      if(nowRelative > 0) {
        remainingPrefix = <Trans>date_price_progress.to_end</Trans>;
        remainingSuffix = moment(new Date(nowUnix * 1000), dateFormat).to(lastDate);
      }
      
      if(nowRelative > period) {
        remainingPrefix = "";
        remainingSuffix = <Trans>date_price_progress.sale_has_ended</Trans>;
      }

      var textElement =
        <small className="justify-content-center d-flex position-absolute w-100">
          Price Bar
        </small>;

      var mainElement =
        <div className="position-relative">
          {textElement}
          <ProgressBar min={0} max={period}>
            
            {firstProgress}
            {secondProgress}
            {thirdProgress}
            
          </ProgressBar>
        </div>;

      if(this.props.textOnly) {
          return <div>{remainingPrefix}{remainingSuffix}</div>;
      }
      else {
        return mainElement;
      }
    }
    
    return '--';
  }
};

export default DatePriceProgress;